import isEmpty from 'is-empty';
import { ADD_BVN_DETAILS, VERIFY_ADD_BVN_ISLOADING } from '../../actions/types';

const initialState = {
  success: false,
  addBvn: {},
  addBvnLoading: false
};

const addBvn = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BVN_DETAILS:
      return {
        ...state,
        success: !isEmpty(action.AddBvnDetails),
        addBvn: action.AddBvnDetails,
        addBvnLoading: false,
      };
    case VERIFY_ADD_BVN_ISLOADING:
      return {
        ...state,
        addBvnLoading: true
      };
    default: return state;
  }
};

export default addBvn;
